var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmexPaymentCard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 5h27v25H25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.726 8.585l1.156-3.054H52V4a4 4 0 00-4-4H4a4 4 0 00-4 4v27a4 4 0 004 4h44a4 4 0 004-4v-1.53h-4.87l-1.816-2.147-1.816 2.064H29.795V18.408h-4.54L30.95 5.613h5.53l1.32 2.89v-2.89h6.852l1.073 2.972zm-3.797.825l.495 1.239 2.312 6.108h2.146l2.311-6.108.413-1.239v7.264H52V7.347h-3.962l-1.816 4.705-.496 1.32-.495-1.32-1.816-4.705h-3.962v9.245h2.476V9.41zm-5.118 7.182h2.724l-4.127-9.328h-3.22l-4.127 9.328h2.724l.743-1.816h4.54l.743 1.816zm-3.467-6.108l.496-1.156.495 1.155.99 2.394h-2.889l.908-2.394zm-1.65 7.924v9.328h7.759v-2.064h-5.448v-1.65h5.283V22.04h-5.283v-1.65h5.448v-1.982h-7.76zm16.509 9.163h3.054l-4.375-4.623 4.375-4.622h-3.054l-2.807 3.054-2.806-3.054h-3.137l4.375 4.705-4.375 4.622h2.971l2.807-3.054 2.972 2.972zm1.155-4.54L52 25.755v-5.366l-2.642 2.642z",
    fill: "#006FCF"
  })));
}

export default SvgAmexPaymentCard;